<template>
    <loading
        v-model:active="mostrarLoader"
        color="#001f54"
        loader="dots"
    />

    <section id="tour_details_main" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="tour_details_top_heading">
                    <h2>{{ $t('titles.ticket_purchase') }}</h2>
                    <h5><i class="fas fa-map-marker-alt"></i> Baltra, {{ $t('labels.galapagos')}}</h5>
                </div>
                <div class="col-lg-7">
                    <div class="tour_details_leftside_wrapper">
                        <div class="tour_details_heading_wrapper">
                            <!-- <div class="tour_details_top_heading_right">
                                <h4>Excellent</h4>
                                <h6>4.8/5</h6>
                                <p>(1214 reviewes)</p>
                            </div> -->
                        </div>
                        <!-- <div class="tour_details_top_bottom d-flex">
                            <div class="toru_details_top_bottom_item">
                                <div class="tour_details_top_bottom_icon">
                                    <i class="fas fa-clock"></i>
                                </div>
                                <div class="tour_details_top_bottom_text">
                                    <h5>Time</h5>
                                    <p>4 hours</p>
                                </div>
                            </div>
                            <div class="toru_details_top_bottom_item">
                                <div class="tour_details_top_bottom_icon">
                                    <i class="fas fa-paw"></i>
                                </div>
                                <div class="tour_details_top_bottom_text">
                                    <h5>Tour type</h5>
                                    <p>Group</p>
                                </div>
                            </div>
                            <div class="toru_details_top_bottom_item">
                                <div class="tour_details_top_bottom_icon">
                                    <i class="fas fa-users"></i>
                                </div>
                                <div class="tour_details_top_bottom_text">
                                    <h5>Group size</h5>
                                    <p>10 people</p>
                                </div>
                            </div>
                            <div class="toru_details_top_bottom_item">
                                <div class="tour_details_top_bottom_icon">
                                    <i class="fas fa-map-marked"></i>
                                </div>
                                <div class="tour_details_top_bottom_text">
                                    <h5>Location</h5>
                                    <p>Baltra</p>
                                </div>
                            </div>
                        </div> -->
                        <div class="tour_details_img_wrapper">
                            <div class="image__gallery">
                                <div class="gallery">
                                    <div class="gallery__slideshow">
                                        <div class="gallery__slides">
                                            <div class="gallery__slide">
                                                <img class="gallery__img slick-slide" :src="slide.img" alt=""
                                                    v-for="(slide, index) in gallerySlides" :key="index" :style="{
                                                      display: slideIndex === index ? 'block' : 'none',
                                                      opacity: slideIndex === index ? 1 : 0,
                                                      transition: 'opacity 0.5s ease-in-out',
                                                    }" />

                                            </div>
                                        </div>
                                        <a @click.prevent="move(-1)" class="gallery__prev">&#10095;</a>
                                        <a @click.prevent="move(1)" class="gallery__next">&#10094;</a>
                                    </div>

                                    <div class="gallery__content">
                                        <div class="gallery__items">

                                            <div class="gallery__item" :class="{
                                                'gallery__item--is-acitve': slideIndex === index
                                            }" v-for="(slide, index) in gallerySlides" :key="`item-${index}`">
                                                <img :src="slide.img" @click="currentSlide(index)"
                                                    class="gallery__item-img" />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="tour_details_boxed">
                            <h3 class="heading_theme">Overview</h3>
                            <div class="tour_details_boxed_inner">
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
                                    tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero
                                    eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
                                    takimata sanctus est.
                                </p>
                                <p>
                                    Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.
                                </p>
                                <ul>
                                    <li><i class="fas fa-circle"></i>Buffet breakfast as per the Itinerary</li>
                                    <li><i class="fas fa-circle"></i>Visit eight villages showcasing Polynesian culture
                                    </li>
                                    <li><i class="fas fa-circle"></i>Complimentary Camel safari, Bonfire, and Cultural
                                        Dance at Camp</li>
                                    <li><i class="fas fa-circle"></i>All toll tax, parking, fuel, and driver allowances
                                    </li>
                                    <li><i class="fas fa-circle"></i>Comfortable and hygienic vehicle (SUV/Sedan) for
                                        sightseeing on all days as per the itinerary.</li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="tour_details_right_sidebar_wrapper">
                        <!-- <div class="tour_detail_right_sidebar">
                            <div class="tour_details_right_boxed">
                                <div class="tour_details_right_box_heading">
                                    <h3>Why choose us</h3>
                                </div>

                                <div class="tour_package_details_bar_list first_child_padding_none">
                                    <ul>
                                        <li><i class="fas fa-circle"></i>Buffet breakfast as per the Itinerary</li>
                                        <li><i class="fas fa-circle"></i>Visit eight villages showcasing Polynesian
                                            culture
                                        </li>
                                        <li><i class="fas fa-circle"></i>Complimentary Camel safari, Bonfire,</li>
                                        <li><i class="fas fa-circle"></i>All toll tax, parking, fuel, and driver
                                            allowances
                                        </li>
                                        <li><i class="fas fa-circle"></i>Comfortable and hygienic vehicle</li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class="tour_details_boxed" style="margin-top:20px; margin-bottom:30px;">
                            <h3 class="heading_theme">{{ $t('titles.location') }}</h3>
                            <div class="map_area">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15504.48010739874!2d-90.28466783874812!3d-0.4431446288496535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9aaa8d790dc08895%3A0xcdb550960f32a8ba!2sAeropuerto%20Seymour!5e0!3m2!1ses!2sec!4v1734384344006!5m2!1ses!2sec"></iframe>
                            </div>
                        </div> -->

                        <div class="tour_detail_right_sidebar">
                            <h3 class="heading_theme">{{ $t('titles.details') }}</h3>

                            <div class="row mb-4 d-flex justify-content-center">
                                <div class="col-lg-5">
                                    <select class="form-select form-control" aria-label="Default select example" v-model="tipoViaje">
                                        <option value="ROUNDTRIP">{{ $t('labels.tour_roundtrip') }}</option>
                                        <option value="ENTRANCE">{{ $t('labels.tour_entrance') }}</option>
                                        <option value="DEPARTURE">{{ $t('labels.tour_departure') }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-4" v-if="tipoViaje==='ENTRANCE' || tipoViaje==='DEPARTURE'">
                                    <flat-pickr v-model="dateDesde" class="form-control" :placeholder="$t('labels.from_date')" :config="dateConfigDesde"/>
                                </div>

                                <div class="col-lg-3">
                                    <div class="form-group" style="text-align: right!important;">
                                        <input class="form-control bg_input" style="text-align: right!important;" :placeholder="$t('labels.tickets_number')" type="number" v-model="dynamicTicketModel"  min="1" max="40">
                                    </div>
                                </div>

                                <!-- <div class="col-lg-3 select_person_right d-flex justify-content-center align-items-center">
                                    <div class="button-set">
                                        <button type="button" @click="reduceTicket(tipoViaje)">
                                            <i class="fas fa-caret-down" style="font-size:30px;"></i>
                                        </button>
                                        <span style="font-size:40px;"><b>{{ getTicketsNumber(tipoViaje) }}</b></span>
                                        <button type="button" @click="increaseTicket(tipoViaje)">
                                            <i class="fas fa-caret-up" style="font-size:30px;"></i>
                                        </button>
                                    </div>
                                </div> -->
                            </div>

                            <div class="row mb-4 d-flex justify-content-center" v-if="tipoViaje==='ROUNDTRIP'">
                                <div class="form-group col-lg-6 col-md-12">
                                    <flat-pickr v-model="dateDesde" class="form-control" :placeholder="$t('labels.from_date')" :config="dateConfigDesde"/>
                                </div>
                                <div class="form-group col-lg-6 col-md-12">
                                    <flat-pickr :key="dateDesde" v-model="dateHasta" class="form-control" :placeholder="$t('labels.to_date')" :config="dateConfigHasta"/>
                                </div>
                            </div>

                            <div class="tour_details_right_boxed">
                                <div class="text-center">
                                    <p style="font-size: 14px;">{{ $t('labels.limit_tickets')}}</p>
                                </div>

                                <div class="tour_package_details_bar_price pt-0">
                                    <!-- <h5>Price</h5> -->
                                    <div class="d-flex justify-content-between align-items-center select_person_item" v-for="recorrido in filteredRecorridos" :key="recorrido.token">
                                        <div class="tour_package_bar_price">
                                            <div class="select_person_left">
                                                <div class="d-flex">
                                                    <h3 style="padding-left:0;">{{ recorrido.nombre }}</h3>
                                                    <i v-if="recorrido.descripcion" class="fas fa-info-circle text-muted" style="font-size:15px;" v-tooltip="recorrido.descripcion"></i>
                                                </div>
                                                <p>{{ $t('labels.'+recorrido.codigo.toLocaleLowerCase()) }}</p>
                                            </div>
                                            <!-- <h3>$ {{ pricePerTicket.toFixed(2) }} <sub></sub> </h3> -->
                                        </div>
                                        <div class="select_person_right" style="font-size:20px;">
                                            $ {{ recorrido.precio.toFixed(2) }}
                                            <b>X {{ getTicketsNumber(recorrido.codigo) }} <i class="fas fa-user"></i></b>
                                        </div>
                                    </div>
                                    <div class="tour_booking_amount_area">
                                        <!-- <ul>
                                            <li>Ticket x {{ ticketsNumber }} <span>$ {{ calculateSubtotal }}</span></li>
                                            <li>Discount <span>-10%</span></li>                                   
                                        </ul> -->
                                        <div class="tour_bokking_subtotal_area" style="padding-bottom: 15px;">
                                            <h6 class="p-0">{{ $t('labels.subtotal') }} <span style="font-size:20px;">$ {{ calculateSubtotal }}</span></h6>
                                            <h6 class="p-0">{{ $t('labels.tax') }} (0%)<span style="font-size:20px;">$ {{ calculateTax }}</span></h6>
                                        </div>
                                        <!-- <div class="coupon_add_area">
                                            <h6><span class="remove_coupon_tour">Remove</span> Coupon code (OFF 5000)
                                                <span>$5,000.00</span>
                                            </h6>
                                        </div> -->
                                        <div class="total_subtotal_booking" style="border-top: 1px solid #dadada">
                                            <b><h6>{{ $t('labels.total') }} <span style="font-size:20px;">$ {{ calculateTotal }}</span></h6></b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tour_select_offer_bar_bottom">
                                <button @click="makeCheckout" class="btn btn_theme btn_md w-100">
                                    {{ $t('messages.go_checkout') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from '@/axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {convertPickerToDate} from "@/assets/utils/actions";

export default {
    name: "TourSearchTwo",

    data() {
        return {
            ticketsEntranceNumber: 0,
            ticketsDepartureNumber: 0,
            ticketsRoundtripNumber: 0,
            //ticketsOnewayNumber: 0,

            pricePerOnewayTicket: 5.00,
            pricePerRoundtripTicket: 10.00,
            subtotal: 0.00,
            tax: 0.00,
            total: 0.00,
            taxPercentage: 0.00,
            recorridos: [],
            filteredRecorridos: [],
            tipoViaje: "ENTRANCE",

            dateDesde: '',
            dateHasta: '',

            dateConfigDesde: {
                wrap: true, // set wrap to true only when using 'input-group'
                dateFormat: 'd/m/Y',
                disable: [
                    this.disableDatesDesde
                ]
            },

            dateConfigHasta: {
                wrap: true, // set wrap to true only when using 'input-group'
                dateFormat: 'd/m/Y',
                disable: [
                    this.disableDatesHasta
                ]
            },

            gallerySlides: [
                { img: require('@/assets/img/tour/tour-1.webp') },
                { img: require('@/assets/img/tour/tour-2.webp') },
                { img: require('@/assets/img/tour/tour-3.webp') },
                { img: require('@/assets/img/tour/tour-4.webp') },
                { img: require('@/assets/img/tour/tour-5.webp') }
            ],

            slideIndex: 0,

            slides: [
                { img: require('@/assets/img/tour/tour-1.webp') },
                { img: require('@/assets/img/tour/tour-2.webp') },
                { img: require('@/assets/img/tour/tour-3.webp') },
                { img: require('@/assets/img/tour/tour-4.webp') },
                { img: require('@/assets/img/tour/tour-5.webp') }
            ],
            mostrarLoader: false,
            limitePrecompraOneway: 7,
            limitePrecompraRoundtrip: 60,

            limiteTicketsEntrance: 40,
            limiteTicketsDeparture: 40,
            limiteTicketsRoundtrip: 40,
        }
    },
    components: {
        Loading,
        flatPickr
    },
    methods: {
        disableDatesDesde(date) {
            //let limitePrecompra = this.tipoViaje === 'ROUNDTRIP' ? this.limitePrecompraRoundtrip : this.limitePrecompraOneway
            let today = new Date();
            let maxSelectableDate = new Date();
            maxSelectableDate.setDate(today.getDate() + this.limitePrecompraOneway);

            return date < today.setDate(today.getDate() - 1) || date > maxSelectableDate;
        },
        disableDatesHasta(date) {
            //let limitePrecompra = this.tipoViaje === 'ROUNDTRIP' ? this.limitePrecompraRoundtrip : this.limitePrecompraOneway
            if(this.dateDesde === "" || this.dateDesde === null){
                let today = new Date();
                let maxSelectableDate = new Date();
                maxSelectableDate.setDate(today.getDate() + this.limitePrecompraRoundtrip);

                return date < today.setDate(today.getDate() - 1) || date > maxSelectableDate;
            }
            else{
                let fechaReferencia = convertPickerToDate(this.dateDesde)
                let maxSelectableDate = new Date(fechaReferencia);
                maxSelectableDate.setDate(fechaReferencia.getDate() + this.limitePrecompraRoundtrip);

                return date < fechaReferencia.setDate(fechaReferencia.getDate()) || date > maxSelectableDate;
            }
        },
        move(n) {
            if (this.gallerySlides.length <= this.slideIndex + n) {
                this.slideIndex = 0
            } else if (this.slideIndex + n < 0) {
                this.slideIndex = this.gallerySlides.length - 1
            } else {
                this.slideIndex += n
            }
        },
        currentSlide(index) {
            this.slideIndex = index
        },
        increaseTicket(type) {
            let ticketType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
            const property = `tickets${ticketType}Number`
            const propertyLimiteTickets = `limiteTickets${ticketType}`
            if (this[property] < this[propertyLimiteTickets]) {
                this[property]++;
            }
        },
        reduceTicket(type){
            let ticketType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
            const property = `tickets${ticketType}Number`
            if (this[property] > 0) {
                this[property]--;
            }
        },
        getRecorridos(){
            this.openLoadingInDiv()
            axios
            .post("api", {
            query: `query recorridos{
                      recorridos{
                          recorridos{
                              token
                              nombre
                              descripcion
                              codigo
                              precio
                              tipo
                          }
                          limitePrecompra
                          status
                          message
                      }
                  }`
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.recorridos.status === 'success') {
                        this.recorridos = response.data.data.recorridos.recorridos
                        let component = this
                        this.filteredRecorridos = this.recorridos.filter(item => item.tipo === component.tipoViaje)
                        this.limitePrecompra = response.data.data.recorridos.limitePrecompra
                        this.getTravelTypeFromStorage()
                        this.getDatesFromStorage()
                        this.getAmountTicketsFromStorage()
                    } else {
                        this.$swal({
                            title: 'Error',
                            text: response.data.data.recorridos.message,
                            icon: 'error',
                            confirmButtonColor: '#001F54',
                        })
                    }
                }
                this.closeLoadingInDiv()
            })
        },
        getTicketsNumber(type){
            if(type){
                let ticketType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                return this[property]
            }
            return 0
        },
        setTicketsNumber(val) {
            const ticketType = this.tipoViaje.charAt(0).toUpperCase() + this.tipoViaje.slice(1).toLowerCase();
            const property = `tickets${ticketType}Number`;

            if (Number.isInteger(val) && val >= 0 && val <= this.limiteTicketsRoundtrip) {
                this[property] = val;
            }
            else{
                this[property] = 1;
            }
        },
        makeCheckout(){
            this.setAmountTicketsToStorage()
            this.setDatesToStorage()
            this.setTravelTypeToStorage()
            this.$router.push("checkout")
        },
        getAmountTicketsFromStorage(){
            for(let recorrido of this.recorridos){
                let ticketType = recorrido.codigo.charAt(0).toUpperCase() + recorrido.codigo.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                if(localStorage.getItem(`ticket${ticketType}Number`) !== null && localStorage.getItem(`ticket${ticketType}Number`) !== ''){
                    this[property] = parseInt(localStorage.getItem(`ticket${ticketType}Number`))
                }
                else{
                    this[property] = 0
                }
            }
            this.setAmountTicketsToStorage()
        },
        setAmountTicketsToStorage(){
            for(let recorrido of this.recorridos){
                let ticketType = recorrido.codigo.charAt(0).toUpperCase() + recorrido.codigo.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                localStorage.setItem(`ticket${ticketType}Number`, this[property])
            }
        },
        getDatesFromStorage(){
            this.dateDesde = localStorage.getItem('dateFrom')
            this.dateHasta = localStorage.getItem('dateTo')

            this.setDatesToStorage()
        },
        setDatesToStorage(){
            localStorage.setItem('dateFrom', this.dateDesde)
            localStorage.setItem('dateTo', this.dateHasta)
        },
        getTravelTypeFromStorage(){
            if(localStorage.getItem('travelType') !== null && localStorage.getItem('travelType') !== ''){
                this.tipoViaje = localStorage.getItem('travelType')
            }

            this.setTravelTypeToStorage()
        },
        setTravelTypeToStorage(){
            localStorage.setItem('travelType', this.tipoViaje)
        },
        openLoadingInDiv(){
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
        },
        startImageSlider() {
            setInterval(() => {
                this.slideIndex = (this.slideIndex + 1) % this.gallerySlides.length;
            }, 5000); // Change image every 3 seconds
        },
    },
    computed: {
        calculateAmountTickets(){
            let total = 0
            total = this.ticketsRoundtripNumber + this.ticketsEntranceNumber + this.ticketsDepartureNumber

            return total
        },
        calculateSubtotal(){
            let subtotal = 0.00
            subtotal = (this.ticketsRoundtripNumber * this.pricePerRoundtripTicket) + (this.ticketsEntranceNumber + this.ticketsDepartureNumber) * this.pricePerOnewayTicket

            return subtotal.toFixed(2)
        },
        calculateTax(){
            let tax = 0.00
            tax = this.taxPercentage * this.calculateSubtotal

            return tax.toFixed(2)
        },
        calculateTotal(){
            let total = 0.00
            total = parseFloat(this.calculateSubtotal) + parseFloat(this.calculateTax)

            return total.toFixed(2)
        },
        dynamicTicketModel: {
            get() {
                return this.getTicketsNumber(this.tipoViaje)
            },
            set(val) {
                return this.setTicketsNumber(val)
            }
        }
    },
    watch: {
        tipoViaje(newValue, oldValue){
            this.filteredRecorridos = this.recorridos.filter(item => item.tipo === newValue)
            let ticketType = oldValue.charAt(0).toUpperCase() + oldValue.slice(1).toLowerCase()
            const property = `tickets${ticketType}Number`
            this[property] = 0
        }
    },
    mounted(){
        this.getRecorridos()
        this.startImageSlider()
    }
};
</script>
